import React from 'react'
import { Control } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { getMinDepositRate } from './utils/get-min-deposit-rate'
import { INPUT_TYPES, InputTypeText } from '../../../../../../../forms'

interface IDepositSectionProps {
  startDate: Date
  control: Control<any, any>
  depositRate: string
}

const DepositSection = ({
  startDate,
  control,
  depositRate,
}: IDepositSectionProps) => {
  const intl = useIntl()
  const minDepositRate = getMinDepositRate(startDate)

  return (
    <div className={s.inputDepositSection}>
      <div className='text-base font-bold'>
        <FormattedMessage
          id='ui.DepositSection.depositRate'
          defaultMessage='Pourcentage du montant à payer en acompte par le client'
        />
      </div>
      <p className={s.rateDetail}>
        <FormattedMessage
          id='ui.DepositSection.rateDetail'
          defaultMessage='Acompte : 60% minimum. 70% minimum à M-2 mois. 100% à M-1 mois'
        />
      </p>
      <InputTypeText
        inputType={INPUT_TYPES.VAT}
        placeholder={`${intl.formatMessage({ id: 'ui.DepositSection.byDefault', defaultMessage: 'Par défaut :' })} ${minDepositRate}%`}
        control={control}
        name='depositRate'
        rules={{}}
        max={100}
        min={minDepositRate}
        units='%'
        value={depositRate}
      />
    </div>
  )
}

export default DepositSection
